import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';

/*
 * This component replicates margin/padding/border styles the @atlaskit/inline-edit component adds around
 * its "read view". The goal is to avoid styling inconsistencies in places where we *conditionally* render
 * an inline edit, e.g. as a suspense placeholde or a read-only mode. Example usage:
 *
 * return canEdit
 *      ? <InlineEdit readView={() => <ReadView />} {...otherProps} />
 *      : <InlineEditReadViewContainer><ReadView /></InlineEditReadViewContainer>
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const InlineEditReadViewContainer = styled.div({
	marginTop: token('space.100', '8px'),
	border: '2px solid transparent',
	lineHeight: 1,
});
